"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DevelopmentDeviceConnector = void 0;
const platform_1 = require("../../../platform");
class DevelopmentDeviceConnector {
    constructor(caller, listeners) {
        this.webViewPlatform = platform_1.Platform.WEB;
        this.areToolsLoaded = () => !!this.caller;
        this.isAnyoneListening = () => true;
        this.call = (type, payload) => {
            this.caller(this, type, payload);
        };
        this.listen = (callback) => {
            this.listeners = [...this.listeners, callback];
        };
        this.sendEventFromMockedMobile = (type, data) => {
            this.listeners.forEach(listener => {
                listener(type, data);
            });
        };
        this.caller = caller;
        this.listeners = listeners;
    }
}
exports.DevelopmentDeviceConnector = DevelopmentDeviceConnector;
//# sourceMappingURL=deviceConnectorDevelopment.js.map